import { createContext } from "react";

export type ChatBotContextValue = {
  isInitialized: boolean;
  show: () => void;
  hide: () => void;
  toggle: () => void;
};

export const ChatBotContext = createContext<ChatBotContextValue | null>(null);
